/** Compose the message home: the last frame with the two clocks and the choice written on it. */
export function makePostcard(frame: HTMLCanvasElement, lines: string[], title: string): HTMLCanvasElement {
  const W = 1280, H = 720;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const g = c.getContext('2d')!;
  g.fillStyle = '#000'; g.fillRect(0, 0, W, H);
  // cover-fit the frame
  const fa = frame.width / frame.height, ca = W / H;
  let sw = frame.width, sh = frame.height, sx = 0, sy = 0;
  if (fa > ca) { sw = frame.height * ca; sx = (frame.width - sw) / 2; } else { sh = frame.width / ca; sy = (frame.height - sh) / 2; }
  g.drawImage(frame, sx, sy, sw, sh, 0, 0, W, H);
  // bottom band
  const grd = g.createLinearGradient(0, H * 0.55, 0, H); grd.addColorStop(0, 'rgba(0,0,0,0)'); grd.addColorStop(1, 'rgba(0,0,0,0.85)');
  g.fillStyle = grd; g.fillRect(0, H * 0.55, W, H * 0.45);
  g.fillStyle = '#e3b45a'; g.font = '700 44px Anybody, Arial Narrow, sans-serif'; g.textBaseline = 'alphabetic';
  g.fillText(title, 56, H - 150);
  g.fillStyle = '#ece8df'; g.font = '400 26px "Source Serif 4", Georgia, serif';
  lines.forEach((l, i) => g.fillText(l, 56, H - 108 + i * 34));
  g.fillStyle = '#a9abbd'; g.font = '500 18px Anybody, Arial Narrow, sans-serif';
  g.fillText('Bending the Milky Way', W - 280, H - 36);
  return c;
}
